import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M1.5 0C0.671573 0 0 0.671573 0 1.5V2.875H7H14V1.5C14 0.671573 13.3284 0 12.5 0H1.5ZM0 8.37488V4.125H6.375V8.37488H0ZM0 9.62488V12.5C0 13.3284 0.671573 14 1.5 14H6.375V9.62488H0ZM7.625 9.62488V14H12.5C13.3284 14 14 13.3284 14 12.5V9.62488H7.625ZM14 8.37488V4.125H7.625V8.37488H14Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }